(function($){

	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: false,
			// prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.77 70 8.15 35.01 20.93 0 13.02 0 0 35 13.02 70 20.77 70"/></svg></button>',
			// nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: false,
			fade: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 3000,
			pauseOnHover: false
		});
	};

	var heroVideo = function() {

		$('[data-action="hero-popup-play"]').on('click', function(e) {
			e.preventDefault();

			var heroVideoModal = document.getElementById('hero-video-modal');
			var heroVideoModalObj = $('#hero-video-modal');

			$.magnificPopup.open({
				mainClass: 'hero-popup',
				items: {
					src: '#hero-video-modal-container',
					type: 'inline',
				},
				callbacks: {
					open: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.play();
						}
					},
					close: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.pause();
							heroVideoModal.currentTime = 0;
						}
					},
				}
			}, 0);
			
		});
		
		$('[data-action="hero-popup-embed"]').magnificPopup({
			type: 'iframe',
			// mainClass: 'hero-popup'
		});


	};


	var scrollAnim = function(){

		///** convert to use intersectionObserver **///

		var win = $(window);

		var items = $('.scroll-animate-item');

		var itemScrollCheck = function(){

			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .9) + winTop;

			items.each(function(i, el){

				var item = $(el);
				var itemTop = item.offset().top;

				if(itemTop <= scrollTriggerPos){
					item.addClass('vis');
				}
				else{
					item.removeClass('vis');
				}

			});

		};

		itemScrollCheck();
		optimizedScroll.add(itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			window.scrollTo(0,1);

			$( 'body' ).removeClass( 'nav-open' );
			
			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 501;

				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 1000);

				}, waitTime);
			}
		}

		$('.filter-dropdown a').on('click', function(e) {

			if($(this).hasClass('no-scroll')){
				e.preventDefault();
				e.stopPropagation();

				// console.log($(this).parents('.filter-dropdown'));

				$(this).parents('.filter-dropdown').removeClass('active');

				return;
			}
			// else if(this.hash){
			// 	if( $(this.hash).length ){
			// 		e.preventDefault();
			// 	}
			// }
		});

		$('.scroll-to-anchor a, a[href^="#"]').on('click', function(e){
			
			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 0;
					
					if(!$('body').hasClass('scrolled')){
						waitTime = 501;
						$('body').addClass('scrolled');
					}

					setTimeout(function(){
						var anchorPosition = hashTarget.offset().top;
						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						$("html, body").animate({scrollTop: finalPosition}, 1000);

						$( 'body' ).removeClass( 'nav-open' );

					}, waitTime);
				}
			}
		});
	};

	
	Number.prototype.countDecimals = function () {

		if (Math.floor(this.valueOf()) === this.valueOf()){
			return 0;
		}

		var str = this.toString();
		if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
			return str.split("-")[1] || 0;
		}
		else if (str.indexOf(".") !== -1) {
			return str.split(".")[1].length || 0;
		}

		return str.split("-")[1] || 0;
	}

	var animateNumbers = function(){
		
		var win = $(window);

		function animateValue(obj, start, end, duration) {
					// console.log(obj, start, end, duration);

			if($(obj).attr('data-anim') == 'true'){
				$(obj).attr('data-anim', 'false');

				var endDecimals = end.countDecimals();
				// console.log(endDecimals);

				let startTimestamp = null;
				const step = (timestamp) => {
					if (!startTimestamp){
						startTimestamp = timestamp;
					}
					const progress = Math.min((timestamp - startTimestamp) / duration, 1);
					// obj.innerHTML = Math.floor(progress * (end - start) + start);
					var numDecimals = progress * (end - start) + start;
					// var numFinal;
					
					if(end % 1 != 0){
						// obj.innerHTML = numDecimals.toFixed(endDecimals).toLocaleString();
						obj.innerHTML = numDecimals.toLocaleString(undefined, {minimumFractionDigits: endDecimals, maximumFractionDigits: endDecimals});
					}
					else{
						obj.innerHTML = Math.floor(numDecimals).toLocaleString();
					}
					if (progress < 1) {
						window.requestAnimationFrame(step);
					}
					else{
						// obj.innerHTML = 0;
						// $(obj).attr('data-anim', 'true');
						// console.log('done');
					}
				};
				window.requestAnimationFrame(step);
			}
		}

		$('.number-container').each(function(i,el){
			var elObj = $(el);
			var thisNum = elObj.attr('data-number');
			var thisPrepend = elObj.attr('data-prepend');
			var thisAppend = elObj.attr('data-append');
			var thisNumAnim = elObj.find('.number-anim');
			elObj.prepend('<span class="number-placeholder">' + '<span class="prepend">' + thisPrepend + '</span>' + thisNum + '<span class="append">' + thisAppend + '</span></span>');
			thisNumAnim.attr('data-anim', 'true');
			thisNumAnim.html(0);
		});

		/* stats on scroll */
		var numbersAnim = function(){
			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .99) + winTop;

			$('.number-anim').each(function(i,el){
				
				var numObj = $(el);
				var objTop = numObj.offset().top;
				var num = parseFloat($(el).attr('data-number'));

					if(objTop <= scrollTriggerPos){
						// console.log('scrn');
						animateValue(el, 0, num, 2000);
						$(el).attr('data-anim', 'false');
					}
					else{
					}

					if(objTop > ( winHeight + winTop )){
						// console.log('offscrn');
						animateValue(el, num, 0, 1);
						$(el).html(0);
						$(el).attr('data-anim', 'true');
					}
				
			});
		};

		numbersAnim();
		optimizedScroll.add(numbersAnim);


		/* stats trigger */
		// var statsOpen = false;

		// $('[data-action2="animate-stats"]').on('click', function(e) {
		// 	// $('.home-stats').toggleClass('vis');
		// 	setTimeout(function() {
		// 		if(statsOpen == false){
		// 			// console.log('open');
		// 			$('.number-anim').each(function(i,el){
		// 				var num = parseFloat($(el).attr('data-number'));

		// 				animateValue(el, 0, num, 2000);
		// 				$(el).attr('data-anim', 'false');
		// 			});
		// 			statsOpen = true;
		// 		}
		// 		else{
		// 			// console.log('close');
		// 			$('.number-anim').each(function(i,el){
		// 				var num = parseFloat($(el).attr('data-number'));
		// 				animateValue(el, num, 0, 1);
		// 				$(el).html(0);
		// 				$(el).attr('data-anim', 'true');
		// 			});
		// 			statsOpen = false;
		// 		}
		// 	}, 200);

		// });
	};


	var blockGallery = function() {
		$('.wp-block-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		})
	};

	var brandsMap = function() {
		if($('.brands-map').length){

			var svgMap = $('#map-svg');
			var iconW = 43;
			var iconH = 36;
			var icons = [];

			var positionIcons = function() {

				iconW = $('.state-brand-icon').outerWidth();
				iconH = $('.state-brand-icon').outerHeight();

				svgMap.find('g').each(function(i,el) {
				// svgMap.find('g.has-brands').each(function(i,el) {

					// console.log(el);

					var elObj = $(el);

					// var elId = elObj.attr('id');
					var elId = elObj.attr('data-state');
					
					var bbox = el.getBBox();

					var elBox = {
						// x: bbox.x,
						// y: bbox.y,
						x: elObj.offset().left - svgMap.offset().left,
						y: elObj.offset().top - svgMap.offset().top,
						width: el.getBoundingClientRect().width,
						height: el.getBoundingClientRect().height
					}

					// var iconCenterX = elBox.x + (elBox.width / 2) - (iconW / 2);
					var iconCenterX = elBox.x + (elBox.width / 2);
					// var iconCenterY = elBox.y + (elBox.height / 2) - (iconH / 2.5);
					var iconCenterY = elBox.y + (elBox.height / 2);

					
					var elOffsetX = parseInt(elObj.attr('data-offset-x'));
					var elOffsetY = parseInt(elObj.attr('data-offset-y'));


					$('#state-brand-icon-' + elId).css({
						'left' : iconCenterX + (iconW * (elOffsetX / 100)),
						'top' : iconCenterY + (iconH * (elOffsetY / 100)) - (iconH / 2.5),
					});
					
					if($('#state-brand-popup-' + elId).hasClass('right')){
						$('#state-brand-popup-' + elId).css({
							'left' : iconCenterX + (iconW * (elOffsetX / 100)) + (iconW / 2),
							'top' : iconCenterY + (iconH * (elOffsetY / 100)) + (iconH * 0.1),
						});
					}
					else{
						$('#state-brand-popup-' + elId).css({
							'left' : iconCenterX + (iconW * (elOffsetX / 100)) - (iconW / 2),
							'top' : iconCenterY + (iconH * (elOffsetY / 100)) + (iconH * 0.1),
						});
					}

				});
			};
			positionIcons();
			optimizedResize.add( positionIcons );

			
			$('[data-action="state-popup"]').on('click', function(e) {
				e.stopPropagation();

				var thisObj = $(this);
				// var thisObjId = thisObj.attr('id');
				var thisObjId = thisObj.attr('data-state');
				var thisPopup = $('#state-brand-popup-'+thisObjId);

				$('.state-popup').not(thisPopup).removeClass('vis');
				thisPopup.addClass('vis');
			});

			$('.state-popup').on('click', function(e) {
				e.stopPropagation();
			});

			$(document).on('click', function(e) {
				$('.state-popup').removeClass('vis');
			});

			$('[data-action="brand-popup"]').magnificPopup({
				type: 'inline',
				mainClass: 'brand-popup-mfp'
			});
		}
	};

	var homeTabs = function() {
		$('[data-action="home-tab"]').on('click', function(e){
			e.preventDefault();
			var thisTab = $(this).parents('.tab');

			thisTab.addClass('vis');
			$('.home-tabs').find('.tab').not(thisTab).removeClass('vis');
		});
	};

	var quoteMore = function() {
		$('[data-action="quote-read-more"]').on('click', function(e) {
			e.preventDefault();

			$(this).parents('.part').removeClass('vis');
			$(this).parents('.quote').find('.full').addClass('vis');
		});
	};

	var wordScrolling = function() {
		var words = $('.scrolling-words').find('.word');
		var wordsCount = words.length;
		var wordsVisCount = 5;
		var wordsWidth = 0;

		function getWordsWidth() {
			words.each(function(i,el){
				if(el.offsetWidth > wordsWidth){
					wordsWidth = el.offsetWidth;
				}
			});

			$('.scrolling-words').width(wordsWidth);
		}
		getWordsWidth();
		optimizedResize.add( getWordsWidth );

		if(wordsCount > 1){
			var wordsInterval = setInterval(function(){
				words.each(function(i,el){
					if(parseInt(el.dataset.step) >= (wordsCount-1)){
						el.dataset.step = 0;
						
					}
					else{
						el.dataset.step = parseInt(el.dataset.step) + 1;
						
						// if(parseInt(el.dataset.step) == 3){
						// 	// $('.scrolling-words').width(el.offsetWidth);
						// }
					}
				});
			}, 2000);
		}
		// clearInterval(wordsInterval);
	};

	$(document).ready(function(){
		homeHeroSlider();
		heroVideo();
		scrollAnim();
		scrollToAnchor();
		animateNumbers();
		blockGallery();
		homeTabs();
		brandsMap();
		quoteMore();
		wordScrolling();

		// if($('.brands-map').length){
		// 	$('.brands-map').addClass('loaded');
		// }

        if($('body').hasClass('home')){
        	$('.hero').addClass('vis');
        }
	});

    window.addEventListener('load', function() {
        var videoContainer = $('.hero-video-container');
        videoContainer.addClass('vis');

    }, false);

})(jQuery);

/* Lazy load bg images https://web.dev/lazy-loading-images/ */
// document.addEventListener("DOMContentLoaded", function() {
//   var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

//   if ("IntersectionObserver" in window) {
//     let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("visible");
//           lazyBackgroundObserver.unobserve(entry.target);
//         }
//       });
//     });

//     lazyBackgrounds.forEach(function(lazyBackground) {
//       lazyBackgroundObserver.observe(lazyBackground);
//     });
//   }
// });